import { z } from "zod";

// Regular time is 100% of time worked, and overtime is a new line items showing the cost difference.
// Derived from Estimates(adhoc items), Time-cards,
export const InvoiceLineItemSchema = z.object({
  description: z.string(),
  unit_price: z.number(),
  quantity: z.number(),
  amount: z.number(),
});

export const InvoiceSchema = z.object({
  invoice_number: z.string().optional(),
  invoice_date: z.date().optional(),
  purchase_order_number: z.string().optional(),
  amount_due: z.number().optional(),
  line_items: z.array(InvoiceLineItemSchema),
});

export const EstimateSchema = z.object({
  amount_due: z.number(),
});

export const ExpenseSchema = z.object({
  amount_due: z.number(),
});

export const DocumentTypeSchema = z.enum(["invoice", "estimate", "expense"]);

export const DocumentSchema = z.discriminatedUnion("document_type", [
  z.object({
    document_type: z.literal("invoice"),
    fields: InvoiceSchema,
  }),
  z.object({
    document_type: z.literal("estimate"),
    fields: EstimateSchema,
  }),
  z.object({
    document_type: z.literal("expense"),
    fields: ExpenseSchema, // reused, but must be separate object
  }),
]);
